import { Container } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import Trazability from "../../components/Trazability";

function TrazabilidadIndex({t}){
    let {path} = useRouteMatch();
    return (
        <Container fluid className="my-5">
            <Switch>
                <Route exact path={path}><Trazability /></Route>
            </Switch>            
        </Container>
    )
}

export default withTranslation()(TrazabilidadIndex)